module.exports = __webpack_public_path__ + "static/media/banner-fabryka-krakow.ebc00f35.jpg";